<!--
 * @Autor: Aberg
 * @Date: 2022-09-21 18:30:18
 * @LastEditTime: 2022-09-28 13:45:57
 * @Description: 
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="topic">
    <Header  :columnName="columnName" />
    <div class="content-box">
      <img class="top-banner" :src="banner" alt="">
      <div v-for="(topicItem, topicIndex) in pageData" :key="topicIndex">
        
        <!-- 主要新闻 -->
        <div class="swiper-news" v-if="topicItem.type == 2 && topicItem.location == 1">
          <div class="swiper-box">
            <swiper class="swiper" id="swiper_banner" ref="swiper" :options="swiperOption" v-if="topicItem.child.length > 0">
              <swiper-slide v-for="(item, index) in topicItem.child" :key="index">
                <img class="item" :src="item.cover" alt="" @click="goTopicNext(1, item.id, 'detail', item.jump_url)">
              </swiper-slide>
            </swiper>
            <!-- 按钮 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="news-container">
            <p v-for="(item, index) in topicItem.child" :key="index" :class="{'active': activeIndex == index}" @mouseover="slideTo(index)"
            @click="goTopicNext(1, item.id, 'detail', item.jump_url)">
              {{ item.title }}
            </p>
          </div>
        </div>
        <!-- 封面图文 -->
        <div class="news-block" v-if="topicItem.type == 2 && topicItem.location == 2">
          <p class="news-title-box">
            <span class="title">{{topicItem.title}}</span>
            <!-- 类型区分 文章 or 图文 -->
            <span class="more" @click="goTopicNext(2, topicItem.id, 'list')">更多</span>
          </p>
      
            <!-- 英雄横向列表 -->
            <div class="pic-box">
              
              <div class="pic-list">
                <ul :id="'ul'+topicIndex" style="display: flex;">
                  <li v-for="item in topicItem.child" :key="item.id" @click="goTopicNext(2, item.id, 'detail', item.jump_url)">
                    <img :src="item.cover" />
                    <p class="dot2">{{ item.title }}</p>
                  </li>
                </ul>
              </div>
              <div @click="handleSelect('left', topicIndex)" :class="{'btn btn-l': true, 'disabled': !topicItem.back_left}">
                <svg class="arrow left" viewBox="0 0 40 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path  d="M37.3815033,22.3265219 C36.6487999,23.1247759 35.5109694,23.2134195 34.6884261,22.5924526 L34.3960227,22.3265219 L18.9999266,5.55210741 L3.60383049,22.3265219 C2.87112701,23.1247759 1.73329656,23.2134195 0.910753209,22.5924526 L0.618349854,22.3265219 C-0.114353627,21.5282679 -0.196141812,20.2886427 0.374256618,19.3925114 L0.618349854,19.0739485 L17.5069744,0.673478124 C18.2396779,-0.124775878 19.3775083,-0.213419468 20.2000517,0.407547352 L20.492455,0.673478124 L37.3815033,19.0734868 C38.2061656,19.9719265 38.2061656,21.4280822 37.3815033,22.3265219 Z"></path>
                </svg>
              </div>
              <div @click="handleSelect('right', topicIndex)" :class="{'btn btn-r': true, 'disabled': topicItem.back || topicItem.child.length < 4}">
                <svg class="arrow right" viewBox="0 0 40 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path  d="M37.3815033,22.3265219 C36.6487999,23.1247759 35.5109694,23.2134195 34.6884261,22.5924526 L34.3960227,22.3265219 L18.9999266,5.55210741 L3.60383049,22.3265219 C2.87112701,23.1247759 1.73329656,23.2134195 0.910753209,22.5924526 L0.618349854,22.3265219 C-0.114353627,21.5282679 -0.196141812,20.2886427 0.374256618,19.3925114 L0.618349854,19.0739485 L17.5069744,0.673478124 C18.2396779,-0.124775878 19.3775083,-0.213419468 20.2000517,0.407547352 L20.492455,0.673478124 L37.3815033,19.0734868 C38.2061656,19.9719265 38.2061656,21.4280822 37.3815033,22.3265219 Z"></path>
                </svg>
              </div>
            </div>
        </div>
        <!-- 图文 -->
        <div class="news-block" v-if="topicItem.type == 1">
          <p class="news-title-box">
            <span class="title">{{topicItem.title}}</span>
            <span class="more" @click="goTopicNext(1, topicItem.id, 'list')">更多</span>
          </p>
          <ul class="about">
            <li class="about-item" v-for="(item, index) in topicItem.child" :key="index" @click="goTopicNext(1, item.id, 'detail', item.jump_url)">
              <p class="about-item-title dot">{{item.title}}</p>
              <p class="about-item-bref">{{item.des}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <!-- 友情链接 end -->
    <Footer />
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { topicOpt } from '@/service/api/home'
import "swiper/swiper-bundle.css";
var vm = null
// var ulWidth= null;
var step = document.body.clientWidth / 1920 * 449.5;
console.log(step)
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      columnName:'专题',
      activeIndex: 0,
      swiperOption: {
        // autoplay: {
        //   disableOnInteraction: false
        // },
        loop: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on:{
          slideChange: function(){
            vm.activeIndex = this.realIndex
          }
        },
      },
      canSlide: true,
      // back: false,
      pageData: [],
      banner: ''
    }
  },
  mounted() {
    vm = this
    this.getList()
    
  },
  created() {
    this.id = this.$route.params.id
  },
  methods: {
    getList() {
      const data = {
        'id': this.id
      }
      topicOpt('detail', data).then(res => {
        this.pageData = res.data.data
        this.banner = res.data.banner
        document.documentElement.scrollTop = 0
        this.$nextTick(()=> {
          for (let i = 0; i < this.pageData.length; i++) {
            let item = this.pageData[i]
            item.back = false
            item.back_left = false
            item.activeIndex = 0
            if (item.type == 2 && item.location == 2) {
              let ul = document.getElementById('ul'+i)
              let ulWidth = item.child.length * step;
              item.ulWidth = ulWidth
              ul.style.width = ulWidth + "px";
            }
          }
        })
        
      })
    },
    slideTo(index) {
      if (this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slideToLoop(index, 0, false);//切换到第一个slide，速度为1秒
      } else {
        const swiper_banner = document.getElementById('swiper_banner')
        swiper_banner.swiper.slideToLoop(index, 0, false);//切换到第一个slide，速度为1秒
      }
    },
    handleSelect(type, index) {
      if(!this.canSlide) {
        return;
      }
      this.canSlide = false;
      setTimeout(() => {
        this.canSlide = true;
      }, 300);
      let ul = document.getElementById('ul'+index)
      let left = ul.offsetLeft;
      this.canSlide = false;

      let topicItem = this.pageData[index]

      if (type === "right") {
        if(topicItem.back || topicItem.child.length < 4) return;
        ul.style.left = left - step + "px";
        topicItem.activeIndex++
        // 右侧按钮禁用判断
        if (topicItem.activeIndex + 2 === topicItem.child.length - 1) {
          topicItem.back = true
        }
        // 左侧按钮启用
        topicItem.back_left = true
        this.$set(this.pageData, index, topicItem)
      } else {
        if (left === 0) return;
        ul.style.left = left + step + "px";
        topicItem.activeIndex--
        // 左侧按钮判断
        if (topicItem.activeIndex == 0) {
          topicItem.back_left = false
        }
        // 右侧按钮启用
        topicItem.back = false;
        this.$set(this.pageData, index, topicItem)
      }
    },
    goTopicNext(type = 2, id, path = list, jump_url = '') {
      if (jump_url) {
        window.open(jump_url)
        return
      }
      if (type == 1) {
        this.$router.push(`/news/${path}/${id}/专题`)
        return
      }
      this.$router.push(`/topic/${path}/${id}/专题`)
    }
  }
}
</script>
<style lang="scss" scoped>
.top-banner {
  width: 100%;
  margin-bottom: 0.4rem;
  max-height: 6.8rem;
  object-fit: cover;
}

.content-box {
  min-height: calc(100vh - 3.3rem);
}
.swiper-news {
  width: 14rem;
  margin: 0 auto 0.4rem;
  display: flex;
  justify-content: space-between;
}
.swiper-box {
  width: 9.32rem;
  height: 5.24rem;
  position: relative;
  z-index: 2;
  .swiper {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.1rem;
    }
  }
  
  .swiper-button-prev, .swiper-button-next {
    color: #fff;
    transform: scale(0.6);
    &:hover {
      transform: scale(0.8);
    }
  }   
  .swiper-pagination {
    left: calc(50% - 0.5rem);
    bottom: 0.17rem;
    font-size: 0;
    :deep(.swiper-pagination-bullet) {
      margin: 0 0.05rem;
      width: 0.1rem;
      height: 0.1rem;
      background: #fff;
      opacity: 1;
      // border-radius: 0;
      cursor: pointer;
      // &:hover,
      &.active {
        
        background: #D1000F;
      }
      &.swiper-pagination-bullet-active {
        
        background: #D1000F;
      }
    }
  }
}
.news-container {
  box-sizing: border-box;
  width: 4.28rem;
  height: 5.24rem;
  background: #FFFFFF;
  // box-shadow: 0px 0.02rem 0.12rem 0px #DFDDDD;
  // border-radius: 0.1rem;
  // padding: 0.07rem 0.16rem;
  p {
    box-sizing: border-box;
    // width: 5.38rem;
    height: 0.63rem;
    // line-height: 0.85rem;
    // margin-left: 0.52rem;
    margin-bottom: 0.5rem;
    font-size: 0.2rem;
    line-height: 0.3rem;
    color: #333;
    display: -webkit-box;        
    -webkit-line-clamp: 2; // 行数 
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover, &.active {
      font-weight: bold;
    }
  }
}
.news-block{
  width: 14rem;
  margin: 0 auto 0.5rem;
}
.news-title-box {
  height: 0.48rem;
  background: #E50318;
  padding: 0 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    color: #fff;
    font-size: 0.32rem;
  }
  .more {
    font-size: 0.18rem;
    color: #fff;
    cursor: pointer;
  }
}
.about {
  .about-item {
    border-bottom: 0.01rem solid #e3e3e3;
    color: #333;
    padding: 0.2rem 0;
    cursor: pointer;
    &-title {
      font-size: 0.2rem;
      font-weight: bold;
      margin-bottom: 0.1rem;
    }
    &-bref {
      font-size: 0.16rem;
      text-indent: 0.32rem;
      line-height: 0.3rem;
    }
  }
}
.pic-box {
  box-sizing: border-box;
    margin-top: 0.2rem;
    position: relative;
    width: 100%;
    padding: 0 0.35rem;
    .btn {
      position: absolute;
      top: calc(50% - 0.4rem);
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
      &.disabled {
        cursor: not-allowed;
        .arrow {
          fill: #999999;
          opacity: 0.4;
        }
        &:hover {
          transform: scale(1);
        }
      }
    }
    .arrow {
      height: 0.16rem;
      width: 0.28rem;
      fill: #333;
      &.left {
        transform: rotate(270deg);
      }
      &.right {
        transform: rotate(90deg);
      }
    }
    .btn-l {
      left: 0;
    }
    .btn-r {
      right: 0;
    }

    .pic-list {
      position: relative;
      margin: 0 auto;
      height: 3.3rem;
      // width: 13.8rem;
      overflow: hidden;
      ul {
        position: absolute;
        // height: 4rem;
        // padding-top: 10px;
        left: 0;
        li {
          float: left;
          width: 4.3rem;
          // height: 3rem;
          margin-right: 0.2rem;
          cursor: pointer;
          img {
            box-sizing: border-box;
            width: 4.3rem;
            height: 2.6rem;
            border-radius: 0.1rem;
            object-fit: cover;
          }
          p {
            font-size: 0.2rem;
            margin-top: 0.1rem;
            line-height: 0.28rem;
            height: 0.6rem;
          }
          &:hover {
            img {
              box-shadow: 0px 0.02rem 0.12rem 0px rgba(51,51,51,0.4);
              
            }
            p {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>